import apiClient from '@/api/client';
import type { PaginatedResponse } from '@/api/endpoints/accounting';

export interface AuditLogEntry {
  id: string;
  timestamp: string;
  user_id: string | null;
  user_email: string | null;
  user_name: string | null;
  action: string;
  table_name: string;
  record_id: string | null;
  ip_address: string | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  company_id: string | null;
}

export interface AuditLogParams {
  page?: number;
  per_page?: number;
  start_date?: string;
  end_date?: string;
  user_id?: string;
  table_name?: string;
  record_id?: string;
  action?: string;
}

export interface LoginHistoryEntry {
  id: string;
  user_id: string;
  user_name: string | null;
  user_email: string | null;
  login_at: string;
  logout_at: string | null;
  ip_address: string | null;
  user_agent: string | null;
  browser: string | null;
  os: string | null;
  device_type: string | null;
  location: string | null;
  success: boolean;
  event_type: 'login' | 'logout';
}

export const auditApi = {
  list: (params?: AuditLogParams) =>
    apiClient.get<PaginatedResponse<AuditLogEntry>>('/audit/logs', { params }),

  loginHistory: (params?: { user_id?: string; page?: number; per_page?: number }) =>
    apiClient.get<PaginatedResponse<LoginHistoryEntry>>('/audit/login-history', { params }),

  exportCsv: (params?: AuditLogParams) =>
    apiClient.get('/audit/logs/export', {
      params: { ...params, format: 'csv' },
      responseType: 'blob',
    }),
};
